// @flow
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Select from 'react-select-5';
import { Box, Flex, Position } from '@locus-taxy/neo-ui';
import useClientId from 'common/hooks/useClientId';

import selectComponents from './SelectComponents';
import styles from './selectStyles';
import useProductSettingsList from './useProductSettingsList';
import useFuseSearch from './useFuseSearch';

import variables from 'common/components/core/variables.scss';

const Overlay = () => (
    <Position
        position="fixed"
        backgroundColor="black"
        opacity=".5"
        top={variables.appbarHeight}
        left={variables.leftbarWidth}
        right={0}
        bottom={0}
        zIndex={15}
    />
);

const ProductSettingsSearch = (): React.Node => {
    const [inputValue, setInputValue] = React.useState<string>('');
    const [canShowOverlay, setCanShowOverlay] = React.useState(false);
    const [enableFetchData, setEnableFetchDataFetchData] = React.useState(
        false
    );

    const { t } = useTranslation('platform');

    const { isLoading, data: productSettings } = useProductSettingsList(
        enableFetchData
    );

    const history = useHistory();
    const clientId = useClientId();

    const options = useFuseSearch({ productSettings, searchTerm: inputValue });

    const handleInputChange = (value: string, { action }: any) => {
        if (action === 'input-change') {
            setInputValue(value);
        }
    };

    const handleFocus = () => {
        setEnableFetchDataFetchData(true);
    };

    const handleChange = value => {
        const { uiPath, setting } = value || {};

        setInputValue('');

        const [product, section, module] = uiPath;
        const query = new URLSearchParams();

        query.set('section', section);
        query.set('setting', setting);
        if (module) {
            query.set('module', module);
        }

        history.push({
            pathname: `/client/${clientId}/settings/${product}`,
            search: query.toString()
        });
    };

    const showOverlay = () => {
        setCanShowOverlay(true);
    };

    const hideOverlay = () => {
        setCanShowOverlay(false);
    };

    // Hack: We let Fuse.js to do the search part and always passing the
    // filtered search results returned by Fuse.js to 'options' props.
    // So making true for all options to react-select here.
    const filterOption = () => true;

    return (
        <Flex flex={1}>
            <Box width={432}>
                <Select
                    isLoading={isLoading}
                    options={options}
                    components={selectComponents}
                    styles={styles}
                    maxMenuHeight={400}
                    value={null}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    inputValue={inputValue}
                    onInputChange={handleInputChange}
                    filterOption={filterOption}
                    onMenuOpen={showOverlay}
                    onMenuClose={hideOverlay}
                    placeholder={t('settings.messages.placeholder')}
                />
                {canShowOverlay && <Overlay />}
            </Box>
        </Flex>
    );
};

export default ProductSettingsSearch;
